import { Form, Input } from 'antd';
import React, { useCallback, useEffect } from 'react';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

function ChangeNotesInnerModalA10({
  adoption,
  saving,
  handleFinish,
  onCancel,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (adoption) {
      form.setFieldsValue({
        notes: adoption.notes,
      });
    }
  }, [adoption, form]);

  const _handleFinish = useCallback(
    async (_values) => {
      const { notes, ...values } = _values;
      handleFinish({
        notes,
        ...values,
      });
    },
    [handleFinish],
  );
  return (
    <TaskSomethingForm
      title="Edit Notes"
      form={form}
      onFinish={_handleFinish}
      onCancel={onCancel}
      saving={saving}
    >
      <Form.Item label="Notes" name="notes">
        <Input.TextArea disabled={saving} rows={4} />
      </Form.Item>
    </TaskSomethingForm>
  );
}

export default ChangeNotesInnerModalA10;
